import React from 'react'
import { IBadgeProps } from './interfaces'
import { FiRadio } from 'react-icons/fi'
import { Tooltip } from 'antd'

/**
 * Marks a notification as having been created by a feed, and names the feed in its tooltip.
 *
 * `FiRadio` is stroke-based (`stroke="currentColor"`) and is rendered bare rather than through
 * antd's `Icon` wrapper, which would inject `fill="currentColor"` and flood-fill the outline.
 * Rendering it uncolored lets it inherit alongside the other badges in a row's badge strip,
 * where a source is never shown next to a competing source and an accent colour would only
 * single it out.
 */
export const NotificationFeedBadge: React.FC<IBadgeProps> = (props) => {
    const badge = (
        <span className="icon-feed">
            <FiRadio />
        </span>
    )

    return (
        <span className="notification-feed-badge">
            {props.hideTooltip ? badge : <Tooltip title={props.tooltip || 'Created from Feed'}>{badge}</Tooltip>}
        </span>
    )
}
